import { ValidationSource } from "@skylab-angular-shared/ui";
import { ObservableCollection } from "@skylab-shared/core";
import { ListenersRegistry } from "@skylab-shared/utils";
import { v4 as uuid } from 'uuid';

export abstract class FormValidatorBase extends ListenersRegistry(class {}) {
    protected  validationSource: ValidationSource = {
        validationResult: new ObservableCollection()
    };

    public readonly sun = uuid();


    public get source(): ValidationSource {
        return this.validationSource;
    }

    public dispose(): void {
        this.deregisterAllListeners?.();
    }

    public abstract isValid(): boolean;
}
